export const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
export const committedOptions = [
  { key: 1, text: "Committed", value: true },
  { key: 2, text: "Uncommitted", value: false },
];
export const guidelineVideo = "https://www.youtube.com/embed/AL2Yb4KvybU";
